import React from "react";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";
import { InstallBanner } from "@/components/InstallBanner";

export function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#0D0E11]">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 pb-28 lg:pb-10">
        <InstallBanner />
        {children}
      </main>
      <BottomNav />
    </div>
  );
}
